module.exports = __webpack_public_path__ + "img/2.2cc05d6f.jpg";